/**
 * Formata um número
 * @param value Valor numérico
 * @param decimalPlaces Casas decimais
 * @param unit Unidade de medida (opcional)
 * @returns Texto formatado
 */
export function formatNumber(
  value: number,
  decimalPlaces: number,
  unit?: string,
) {
  const vText = value.toLocaleString("pt-BR", {
    maximumFractionDigits: decimalPlaces,
  });
  return unit ? `${vText} ${unit}` : vText;
}

/**
 * Formata um número como percentual, sendo 0 = 0%, 10 = 100%, 20 = 200%, etc.
 * @param value Valor numérico
 * @param decimalPlaces Casas decimais
 * @returns Texto formatado
 */
export function formatNumberPercentTimes10(
  value: number,
  decimalPlaces: number,
  withPercent: boolean = true,
) {
  return withPercent
    ? (value / 10).toLocaleString("pt-BR", {
        style: "percent",
        maximumFractionDigits: decimalPlaces,
      })
    : (value * 10).toLocaleString("pt-BR", {
        maximumFractionDigits: decimalPlaces,
      });
}

/**
 * Formata um número como percentual, sendo 0 = 0%, 1 = 100%, 2 = 200%, etc.
 * @param value Valor numérico
 * @param decimalPlaces Casas decimais
 * @returns Texto formatado
 */
export function formatNumberPercent(
  value: number,
  decimalPlaces: number,
  positiveValidate?: boolean,
  withPercent: boolean = true,
) {
  const formatted = withPercent
    ? value.toLocaleString("pt-BR", {
        style: "percent",
        maximumFractionDigits: decimalPlaces,
      })
    : (value * 100).toLocaleString("pt-BR", {
        maximumFractionDigits: decimalPlaces,
      });

  if (positiveValidate && value > 0) {
    return `+${formatted}`;
  }

  return formatted;
}

/**
 * Formata um número como moeda, no formato BRL (R$)
 * @param value Valor numérico
 * @returns Texto formatado
 */
export function formatNumberCurrencyBRL(value: number) {
  const vText = value.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
  return vText;
}
export function transformDateFormat(inputDate?: string): string {
  if (!inputDate) return "";
  const [year, month, day] = inputDate.split("-");
  return `${day}/${month}/${year}`;
}

export function getMonthName(monthNumber: number) {
  const date = new Date();
  date.setMonth(monthNumber - 1);

  return date.toLocaleString("pt-BR", { month: "long" });
}

export function getNumDaysMonth(month: number, year: number): number {
  // https://javascript.plainenglish.io/how-to-determine-the-number-of-days-in-a-month-with-javascript-3d837575a398
  return new Date(year, month, 0).getDate();
}

export function getDayOfMonthMiddayUTC(
  date: number,
  month: number,
  year: number,
): Date {
  return new Date(Date.UTC(year, month - 1, date, 12));
}

export function datePtBrDayOfWeekShortWithoutYear(
  date: Date,
  timeZone?: string,
): string {
  return date.toLocaleDateString("pt-BR", {
    weekday: "short",
    day: "2-digit",
    month: "2-digit",

    timeZone,
  });
}
